import axios from "@/lib/request"

export const getRoleMenus = params => {
  return axios.request({
    url: "/v1/admin/cmn/role/menu/list",
    method: "get",
    params
  })
}

export const saveRoleMenus = data => {
  return axios.request({
    url: "/v1/admin/cmn/role/menu/save",
    method: "post",
    data
  })
}

